module.exports = __webpack_public_path__ + "img/cssa_bot.d38747fb.png";